import React, { useState, useEffect } from "react";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { parsePhoneNumberFromString } from "libphonenumber-js";

interface PhoneInputFieldProps {
  value?: string | any;
  onChange?: (value: string, error: boolean) => void;
  onFinish?: (value: string, error: boolean) => void;
  placeholder?: string;
  error?: boolean;
  required?: boolean;
  showError?: boolean;
  isGrid?: boolean;
  variant?: "default" | "inline";
}

const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
  value = "",
  onFinish = () => {},
  placeholder = "",
  error = false,
  isGrid = false,
  variant = "default",
}) => {
  const toE164 = (raw: any): string | undefined => {
    if (!raw) return undefined;
    const str = String(raw).trim();
    if (str === "") return undefined;
    try {
      const parsed = parsePhoneNumberFromString(str, "US");
      return parsed?.number;
    } catch {
      return undefined;
    }
  };

  const [inputValue, setInputValue] = useState<string | undefined>(toE164(value));

  useEffect(() => {
    setInputValue(toE164(value));
  }, [value]);

  const isInline = variant === "inline";
  const borderStyle = error
    ? "border-red-300"
    : isGrid
      ? "outline-none"
      : isInline
        ? "border border-gray-300 rounded-md"
        : "outline-1 -outline-offset-1 outline-gray-300";

  const containerClass = isInline
    ? "flex items-center w-full rounded-md border border-gray-300 px-2 py-1 min-h-[28px]"
    : "";

  return (
    <div className={isInline ? containerClass : ""}>
      <PhoneInput
        className={
          isInline
            ? "w-full [&_input]:text-[12px] [&_input]:leading-4 [&_input]:font-medium [&_input]:text-gray-800 [&_input]:py-0 [&_input]:px-0 [&_input]:border-0 [&_input]:focus:outline-none"
            : `flex py-2 px-2 ${borderStyle}`
        }
        placeholder={placeholder}
        value={inputValue}
        defaultCountry={"US"}
        onBlur={() => {
          const normalized = toE164(inputValue);
          if (normalized != toE164(value)) {
            onFinish(normalized || "", false);
          }
        }}
        onChange={(newValue) => {
          setInputValue(newValue);
        }}
      />
    </div>
  );
};

export default PhoneInputField;
